var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopDownTreeDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7aa90dd152"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 276.832031 88.839844 L 533.167969 88.839844 L 533.167969 345.175781 L 276.832031 345.175781 Z M 276.832031 88.839844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f1db6bd652"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 405 88.839844 C 334.214844 88.839844 276.832031 146.222656 276.832031 217.007812 C 276.832031 287.792969 334.214844 345.175781 405 345.175781 C 475.785156 345.175781 533.167969 287.792969 533.167969 217.007812 C 533.167969 146.222656 475.785156 88.839844 405 88.839844 Z M 405 88.839844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bce83d7e77"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 608.71875 556.726562 L 773.152344 556.726562 L 773.152344 721.160156 L 608.71875 721.160156 Z M 608.71875 556.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bd2ac1096b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 690.933594 556.726562 C 645.527344 556.726562 608.71875 593.535156 608.71875 638.945312 C 608.71875 684.351562 645.527344 721.160156 690.933594 721.160156 C 736.339844 721.160156 773.152344 684.351562 773.152344 638.945312 C 773.152344 593.535156 736.339844 556.726562 690.933594 556.726562 Z M 690.933594 556.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0abf26f466"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 608.71875 556.726562 L 772.96875 556.726562 L 772.96875 720.976562 L 608.71875 720.976562 Z M 608.71875 556.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6c6cd99597"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 690.929688 556.726562 C 645.523438 556.726562 608.71875 593.535156 608.71875 638.941406 C 608.71875 684.34375 645.523438 721.152344 690.929688 721.152344 C 736.335938 721.152344 773.144531 684.34375 773.144531 638.941406 C 773.144531 593.535156 736.335938 556.726562 690.929688 556.726562 Z M 690.929688 556.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "902ce89531"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.847656 556.726562 L 201.28125 556.726562 L 201.28125 721.160156 L 36.847656 721.160156 Z M 36.847656 556.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "466fef820a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 119.066406 556.726562 C 73.660156 556.726562 36.847656 593.535156 36.847656 638.945312 C 36.847656 684.351562 73.660156 721.160156 119.066406 721.160156 C 164.472656 721.160156 201.28125 684.351562 201.28125 638.945312 C 201.28125 593.535156 164.472656 556.726562 119.066406 556.726562 Z M 119.066406 556.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "52f7b49fb9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.847656 556.726562 L 201.097656 556.726562 L 201.097656 720.976562 L 36.847656 720.976562 Z M 36.847656 556.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a1f6fbecef"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 119.0625 556.726562 C 73.65625 556.726562 36.847656 593.535156 36.847656 638.941406 C 36.847656 684.34375 73.65625 721.152344 119.0625 721.152344 C 164.464844 721.152344 201.273438 684.34375 201.273438 638.941406 C 201.273438 593.535156 164.464844 556.726562 119.0625 556.726562 Z M 119.0625 556.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "26edab9c8d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 322.78125 556.726562 L 487.21875 556.726562 L 487.21875 721.160156 L 322.78125 721.160156 Z M 322.78125 556.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c53812f757"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 405 556.726562 C 359.59375 556.726562 322.78125 593.535156 322.78125 638.945312 C 322.78125 684.351562 359.59375 721.160156 405 721.160156 C 450.40625 721.160156 487.21875 684.351562 487.21875 638.945312 C 487.21875 593.535156 450.40625 556.726562 405 556.726562 Z M 405 556.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1bc3fd1045"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 322.78125 556.726562 L 487.03125 556.726562 L 487.03125 720.976562 L 322.78125 720.976562 Z M 322.78125 556.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9b9067db97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 404.996094 556.726562 C 359.589844 556.726562 322.78125 593.535156 322.78125 638.941406 C 322.78125 684.34375 359.589844 721.152344 404.996094 721.152344 C 450.402344 721.152344 487.207031 684.34375 487.207031 638.941406 C 487.207031 593.535156 450.402344 556.726562 404.996094 556.726562 Z M 404.996094 556.726562 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7aa90dd152)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f1db6bd652)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cccccc",
    d: "M 276.832031 88.839844 L 533.167969 88.839844 L 533.167969 345.175781 L 276.832031 345.175781 Z M 276.832031 88.839844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 276.830819, 88.83909)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 170.89225 0.00100509 C 76.512037 0.00100509 0.0016161 76.511426 0.0016161 170.891639 C 0.0016161 265.271852 76.512037 341.782272 170.89225 341.782272 C 265.272463 341.782272 341.782883 265.271852 341.782883 170.891639 C 341.782883 76.511426 265.272463 0.00100509 170.89225 0.00100509 Z M 170.89225 0.00100509 ",
    stroke: "var(--txt-color)",
    strokeWidth: 14,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bce83d7e77)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bd2ac1096b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff4a4a",
    d: "M 608.71875 556.726562 L 773.152344 556.726562 L 773.152344 721.160156 L 608.71875 721.160156 Z M 608.71875 556.726562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0abf26f466)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6c6cd99597)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 608.717013, 556.726744)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 109.616905 -0.000241989 C 49.075235 -0.000241989 0.00231617 49.077885 0.00231617 109.619555 C 0.00231617 170.156017 49.075235 219.234144 109.616905 219.234144 C 170.158575 219.234144 219.236702 170.156017 219.236702 109.619555 C 219.236702 49.077885 170.158575 -0.000241989 109.616905 -0.000241989 Z M 109.616905 -0.000241989 ",
    stroke: "var(--txt-color)",
    strokeWidth: 14,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#902ce89531)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#466fef820a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fb8b24",
    d: "M 36.847656 556.726562 L 201.28125 556.726562 L 201.28125 721.160156 L 36.847656 721.160156 Z M 36.847656 556.726562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#52f7b49fb9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a1f6fbecef)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 36.848805, 556.726744)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 109.618265 -0.000241989 C 49.076595 -0.000241989 -0.0015321 49.077885 -0.0015321 109.619555 C -0.0015321 170.156017 49.076595 219.234144 109.618265 219.234144 C 170.154726 219.234144 219.232854 170.156017 219.232854 109.619555 C 219.232854 49.077885 170.154726 -0.000241989 109.618265 -0.000241989 Z M 109.618265 -0.000241989 ",
    stroke: "var(--txt-color)",
    strokeWidth: 14,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#26edab9c8d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c53812f757)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#33adff",
    d: "M 322.78125 556.726562 L 487.21875 556.726562 L 487.21875 721.160156 L 322.78125 721.160156 Z M 322.78125 556.726562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1bc3fd1045)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9b9067db97)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 322.782938, 556.726744)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 109.617547 -0.000241989 C 49.075877 -0.000241989 -0.00225022 49.077885 -0.00225022 109.619555 C -0.00225022 170.156017 49.075877 219.234144 109.617547 219.234144 C 170.159217 219.234144 219.232136 170.156017 219.232136 109.619555 C 219.232136 49.077885 170.159217 -0.000241989 109.617547 -0.000241989 Z M 109.617547 -0.000241989 ",
    stroke: "var(--txt-color)",
    strokeWidth: 14,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.749996, 0.00249247, -0.00249247, 0.749996, 115.715813, 445.466038)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.00219087 5.998449 L 385.734349 5.997781 ",
    stroke: "var(--txt-color)",
    strokeWidth: 12,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(-0.75, 0, 0, -0.75, 690.925745, 455.427381)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.0000486794 6.002133 L 381.244762 6.002133 ",
    stroke: "var(--txt-color)",
    strokeWidth: 12,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0, -0.75, 0.75, 0, 400.498695, 556.72552)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.00139001 6.001741 L 282.066333 6.001741 ",
    stroke: "var(--txt-color)",
    strokeWidth: 12,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0, 0.75, -0.75, 0, 123.560784, 445.627942)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00128623 5.997712 L 148.13671 5.997712 ",
    stroke: "var(--txt-color)",
    strokeWidth: 12,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0, 0.75, -0.75, 0, 695.430329, 446.578486)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.000480711 6.000855 L 146.869318 6.000855 ",
    stroke: "var(--txt-color)",
    strokeWidth: 12,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopDownTreeDark);
export default __webpack_public_path__ + "static/media/top_down_tree_dark.fdeb0afc9b28298069c1df74370d82ca.svg";
export { ForwardRef as ReactComponent };